import { Fragment } from 'react';
import { MUTUTInspectionOverviewData, PDFTableProps, Project } from '../../../../utils/models';
import { getMUTColumns } from '../../../../utils/data';

import GridItem from '../general/gridItem';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

interface UTMeasurementsProps extends Pick<PDFTableProps, 'data'>, MUTUTInspectionOverviewData {
	projectDetails: Project;
}

const UTMeasurementsOverview = (props: UTMeasurementsProps) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Inspection Standard:"
							value={props.inspectionStd}
						/>
					</div>

					<div className="col">
						<GridItem
							title="Corrosion Allowance:"
							value={props.corrosionAllowance}
						/>
					</div>
				</div>
			</div>

			<div className="container-fluid overflow-hidden">
				<GridItem title="NDE Technique:" value={props.ndeTechnique} />
			</div>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem title="Equipment:" value={props.equipment} />
						<GridItem title="Probe:" value={props.probe} />
						<GridItem title="Calibration Blk:" value={props.calibrationBlk} />
						<GridItem title="Reference Std:" value={props.refStd} />
					</div>

					<div className="col">
						<GridItem title="Serial No:" value={props.serialNo} />
						<GridItem title="Couplant:" value={props.couplant} />
						<GridItem
							title="Amplitude Linearity Check:"
							value={props.amplitudeLinearityCheck}
						/>
						<GridItem
							title="Screen Height Linearity Check:"
							value={props.screenHeightLinearityCheck}
						/>
					</div>
				</div>
			</div>

			<div className="container-fluid overflow-hidden">
				<GridItem title="Scanning Level:" value={props.scanningLevel} />
			</div>

			<PDFTablePage data={props.data} columns={getMUTColumns()} />

			<div className="container-fluid overflow-hidden">
				<GridItem title="Remarks:" value={props.remarks} />
			</div>
		</Fragment>
	);
};

export default UTMeasurementsOverview;
